import {Wrapper} from './styled';
import {Props} from './types';

export function FormField({smallMargin, children}: Props) {
    return <Wrapper $smallMargin={smallMargin}>{children}</Wrapper>;
}
